// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Applicative_Extra from "../Control.Applicative.Extra/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Restaumatic_Calendar_Types_Availability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic_Cart_Cart from "../Restaumatic.Cart.Cart/index.js";
import * as Restaumatic_Cart_ProductItem from "../Restaumatic.Cart.ProductItem/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Menu_V2_AvailabilityValidation from "../Restaumatic.Menu.V2.AvailabilityValidation/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic_Menu_V2_Parametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic_Menu_V2_PriceView from "../Restaumatic.Menu.V2.PriceView/index.js";
import * as Restaumatic_Menu_V2_Types_AvailabilitySchedule from "../Restaumatic.Menu.V2.Types.AvailabilitySchedule/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_MenuSection from "../Restaumatic.Menu.V2.Types.MenuSection/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic_Site_I18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Extra from "../Specular.Extra/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
var shoppingCartIcon = function (isDecorative) {
    var ariaAttr = (function () {
        if (isDecorative) {
            return Specular_Dom_Element.attr("aria-hidden")("true");
        };
        return Specular_Dom_Element.attr("aria-label")(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.menu.add_to_cart));
    })();
    return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("icon-shopping-cart"), ariaAttr ])(Restaumatic_Prelude_Specular.wempty);
};
var sectionItemAvailabilityBadge = function () {
    return function () {
        return Data_NamedParams.mkNamedParamsFn()()({
            showInfoIcon: true
        })(function (v) {
            return Control_Applicative_Extra.whenJust(Specular_Dom_Builder.applicativeBuilder)(Restaumatic_Menu_V2_MenuCatalogue.lookupAvailabilitySchedule(v.catalogue)(v.availabilityScheduleId))(function (schedule) {
                var weeklyAvailability = Data_Record.getField(Restaumatic_Menu_V2_Types_AvailabilitySchedule.hasFieldAvailabilitySched(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "availability";
                    }
                })()))(Type_Proxy["Proxy"].value)(schedule);
                var availabilityStatus = Restaumatic_Calendar_Types_Availability.availabilityStatus(weeklyAvailability)(v.localDateTime);
                return Control_Applicative.when(Specular_Dom_Builder.applicativeBuilder)(Data_Eq.notEq(Restaumatic_Calendar_Types_Availability.eqAvailabilityStatus)(availabilityStatus)(Restaumatic_Calendar_Types_Availability.Available.value))(Specular_Dom_Element.el("span")([ Specular_Dom_Element.classes([ "label", "label-dish", "m-availability__label", "m-availability__label--unavailable" ]) ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)((function () {
                    if (availabilityStatus instanceof Restaumatic_Calendar_Types_Availability.NotAvailableWholeDay) {
                        return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.dish_label.unavailable));
                    };
                    if (availabilityStatus instanceof Restaumatic_Calendar_Types_Availability.NotAvailableAtTheTime) {
                        return Specular_Dom_Element.text(Restaumatic_Calendar_Types_Availability.formatDailyAvailability(availabilityStatus.value0));
                    };
                    return Restaumatic_Prelude_Specular.wempty;
                })())(function () {
                    return Control_Applicative.when(Specular_Dom_Builder.applicativeBuilder)(v.showInfoIcon)(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("icon-info-sign"), Specular_Dom_Element.attr("aria-label")(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.theme.informations)) ])(Restaumatic_Prelude_Specular.wempty));
                })));
            });
        });
    };
};
var itemCountBadge = function (itemCountD) {
    return Specular_FRP_Extra.whenD(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
        return v > 0;
    })(itemCountD))(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("m-item__cart-count") ])(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("m-item__badge"), Specular_Dom_Element.class_("count") ])(Specular_Dom_Element.dynText(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Show.show(Data_Show.showInt))(itemCountD)))));
};
var displayPriceView = function (v) {
    if (v instanceof Restaumatic_Menu_V2_PriceView.Constant) {
        return Specular_Dom_Element.text(Restaumatic_Site_I18n.currency(v.value0.value));
    };
    if (v instanceof Restaumatic_Menu_V2_PriceView.Range) {
        return Specular_Dom_Element.text(Restaumatic_Site_I18n.currency(v.value0.from) + (" \u2013 " + Restaumatic_Site_I18n.currency(v.value0.to)));
    };
    throw new Error("Failed pattern match at Restaumatic.Site.Components.Cart.Integration.Common (line 84, column 1 - line 84, column 45): " + [ v.constructor.name ]);
};
var sectionItemColumn = function (catalogue) {
    return function (cartProductCountFn) {
        return function (sectionParametersD) {
            return function (menuSectionId) {
                return function (menuSectionItemId) {
                    return function (parameterId) {
                        return function (choiceId) {
                            return Control_Applicative_Extra.whenJust(Specular_Dom_Builder.applicativeBuilder)(Restaumatic_Menu_V2_MenuCatalogue.lookupSectionItem(catalogue)(menuSectionId)(menuSectionItemId))(function (v) {
                                if (v instanceof Restaumatic_Menu_V2_Types_MenuSection.SingleProduct) {
                                    return Control_Applicative_Extra.whenJust(Specular_Dom_Builder.applicativeBuilder)(Restaumatic_Menu_V2_MenuCatalogue.lookupProduct(catalogue)(v.value0.itemProduct))(function (product) {
                                        return Specular_FRP_Replaceable.withDynamic_(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(sectionParametersD)(function (sectionParameters) {
                                            var localParameters = Data_Map_Internal.unions(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Data_Foldable.foldableArray)([ Restaumatic_Menu_V2_Parametric.customAssign(parameterId)(choiceId), Restaumatic_Menu_V2_Parametric.fromCustomParameterValues(Data_Newtype.unwrap()(v.value0.customParameterValues)), sectionParameters ]);
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Applicative_Extra.whenJust(Specular_Dom_Builder.applicativeBuilder)(Restaumatic_Menu_V2_PriceView.productPriceView(catalogue)(product)(localParameters))(displayPriceView))(function () {
                                                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Extra.nbsp)(function () {
                                                    return itemCountBadge(cartProductCountFn(v.value0.itemProduct)(localParameters));
                                                });
                                            });
                                        });
                                    });
                                };
                                return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit);
                            });
                        };
                    };
                };
            };
        };
    };
};
var displayAlert = function (msg) {
    return Control_Bind.bind(Effect.bindEffect)(Web_HTML.window)(Web_HTML_Window.alert(msg));
};
var withAvailabilityValidation = function (catalogue) {
    return function (envD) {
        return function (v) {
            return Specular_Callback.mkCallback(function (productKey) {
                return function __do() {
                    var env = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(envD)();
                    var v1 = Restaumatic_Menu_V2_AvailabilityValidation.validateAvailability(catalogue)(env)(productKey);
                    if (v1 instanceof Data_Either.Left) {
                        displayAlert(v1.value0)();
                        return Specular_Callback.triggerCallback(v.openProductCreator)(productKey)();
                    };
                    if (v1 instanceof Data_Either.Right) {
                        return Specular_Callback.triggerCallback(v.next)(productKey)();
                    };
                    throw new Error("Failed pattern match at Restaumatic.Site.Components.Cart.Integration.Common (line 102, column 3 - line 107, column 38): " + [ v1.constructor.name ]);
                };
            });
        };
    };
};
var cartProductCount = function (queryProductId) {
    return function (params) {
        return function (cart) {
            var customParams = Restaumatic_Menu_V2_Parametric.onlyCustomParameterValues(params);
            var matchProduct = function (product) {
                var v = Restaumatic_Cart_ProductItem.productItemKey(product);
                if (v instanceof Restaumatic_Cart_ProductKey.MenuProduct && Data_Array_NonEmpty.length(Data_Newtype.unwrap()(v.value0.parts)) === 1) {
                    var v1 = Data_Array_NonEmpty.head(Data_Newtype.unwrap()(v.value0.parts));
                    return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(v1.productId)(queryProductId) && Data_Map_Internal.isSubmap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(customParams)(Data_Semigroup.append(Data_Map_Internal.semigroupMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(Data_Newtype.unwrap()(v1.customParameters))(Data_Newtype.unwrap()(v.value0.customParameters)));
                };
                return false;
            };
            var cartItems = Restaumatic_Cart_Cart.productItems(cart);
            var cartItem = Data_Foldable.find(Data_Foldable.foldableArray)(matchProduct)(cartItems);
            return Data_Maybe.maybe(0)(Restaumatic_Cart_ProductItem.productItemQuantity)(cartItem);
        };
    };
};
var cartComboCount = function (queryComboId) {
    return function (cart) {
        var matchProduct = function (product) {
            var v = Restaumatic_Cart_ProductItem.productItemKey(product);
            if (v instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(v.value0.comboId)(queryComboId);
            };
            return false;
        };
        var cartItems = Restaumatic_Cart_Cart.productItems(cart);
        var cartItem = Data_Foldable.find(Data_Foldable.foldableArray)(matchProduct)(cartItems);
        return Data_Maybe.maybe(0)(Restaumatic_Cart_ProductItem.productItemQuantity)(cartItem);
    };
};
var caretIcon = /* #__PURE__ */ Specular_Dom_Element.el("span")([ /* #__PURE__ */ Specular_Dom_Element.class_("caret") ])(Restaumatic_Prelude_Specular.wempty);
export {
    sectionItemColumn,
    sectionItemAvailabilityBadge,
    shoppingCartIcon,
    itemCountBadge,
    caretIcon,
    displayPriceView,
    cartComboCount,
    withAvailabilityValidation,
    displayAlert,
    cartProductCount
};
//# sourceMappingURL=index.js.map
